import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { CharacterPage } from './character/character.page';
const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)},
  { path: 'login', loadChildren: './login/login.module#LoginPageModule' },
  { path: 'register', loadChildren: './register/register.module#RegisterPageModule' },
  { path: 'forgot', loadChildren: './forgot/forgot.module#ForgotPageModule' },
  { path: 'create', loadChildren: './create/create.module#CreatePageModule' },
  { path: 'characters', loadChildren: './characters/characters.module#CharactersPageModule' },
  { path: 'roles', loadChildren: './roles/roles.module#RolesPageModule' },
  { path: 'stats', loadChildren: './stats/stats.module#StatsPageModule' },
  { path: 'skills', loadChildren: './skills/skills.module#SkillsPageModule' },
  { path: 'lifepath', loadChildren: './lifepath/lifepath.module#LifepathPageModule' },
  { path: 'gear', loadChildren: './gear/gear.module#GearPageModule' },
    {
        path: 'character', component: CharacterPage, children: [
            { path: '', loadChildren: './create/create.module#CreatePageModule', pathMatch: 'full' },
            { path: 'personal', loadChildren: './personal/personal.module#PersonalPageModule' },
            { path: 'create', loadChildren: './create/create.module#CreatePageModule' },
            { path: 'roles', loadChildren: './roles/roles.module#RolesPageModule' },
            { path: 'stats', loadChildren: './stats/stats.module#StatsPageModule' },
            { path: 'skills', loadChildren: './skills/skills.module#SkillsPageModule' },
            { path: 'gear', loadChildren: './gear/gear.module#GearPageModule' },
            { path: 'lifepath', loadChildren: './lifepath/lifepath.module#LifepathPageModule' },
            ]
        },
  { path: 'select-weapons', loadChildren: './select-weapons/select-weapons.module#SelectWeaponsPageModule' },
  { path: 'select-armor', loadChildren: './select-armor/select-armor.module#SelectArmorPageModule' },
  { path: 'select-cyberware', loadChildren: './select-cyberware/select-cyberware.module#SelectCyberwarePageModule' },
  { path: 'select-gear', loadChildren: './select-gear/select-gear.module#SelectGearPageModule' },
  { path: 'select-cyberware-options', loadChildren: './select-cyberware-options/select-cyberware-options.module#SelectCyberwareOptionsPageModule' },
  { path: 'select-weapons-options', loadChildren: './select-weapons-options/select-weapons-options.module#SelectWeaponsOptionsPageModule' },
  { path: 'select-lifepath', loadChildren: './select-lifepath/select-lifepath.module#SelectLifepathPageModule' },
  { path: 'personal', loadChildren: './personal/personal.module#PersonalPageModule' },
  { path: 'select-programs', loadChildren: './select-programs/select-programs.module#SelectProgramsPageModule' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
